(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-wrap-option"] && !Shopify.designMode) return;
  try {
    class CartAddOns extends HTMLElement {
    connectedCallback() {
      if (this.dataset.removeOrphans === 'true') {
        if (!window.cartAddOnsOrphanCleanupStarted) {
          window.cartAddOnsOrphanCleanupStarted = true;
          this.removeOrphans();
        }
        return;
      }

      this.wrapCheckbox = this.querySelector('[data-wrap-checkbox]');
      this.messageCheckbox = this.querySelector('[data-message-checkbox]');
      this.messageFields = this.querySelector('[data-message-fields]');
      this.messageText = this.querySelector('[data-message-text]');
      this.messageCounter = this.querySelector('[data-message-counter]');
      this.saveButton = this.querySelector('[data-add-ons-save]');
      this.status = this.querySelector('[data-add-ons-status]');
      this.saveLabel = this.saveButton.textContent;

      this.messageCheckbox.addEventListener('change', () => this.toggleMessageFields());
      this.messageText.addEventListener('input', () => this.updateCounter());
      this.saveButton.addEventListener('click', () => this.save());
      this.toggleMessageFields();
      this.updateCounter();
    }

    toggleMessageFields() {
      const enabled = this.messageCheckbox.checked;
      this.messageFields.hidden = !enabled;
      this.messageText.disabled = !enabled;
    }

    updateCounter() {
      this.messageCounter.textContent = `${this.messageText.value.length}/250`;
    }

    async save() {
      const messageSelected = this.messageCheckbox.checked;
      const message = this.messageText.value.trim();

      if (messageSelected && !message) {
        this.status.textContent = this.dataset.required;
        this.messageText.focus();
        return;
      }

      this.setPending(true);
      this.status.textContent = this.dataset.saving;

      try {
        await this.updateWrap(this.wrapCheckbox.checked);
        await this.updateMessage(messageSelected, message);
        window.location.reload();
      } catch (error) {
        this.status.textContent = this.dataset.error;
        this.setPending(false);
      }
    }

    async updateWrap(selected) {
      await this.request('cart/update.js', {
        updates: {
          [this.dataset.wrapVariantId]: selected ? 1 : 0,
        },
      });
    }

    async updateMessage(selected, message) {
      const lineKey = this.dataset.messageLineKey;

      if (!selected && !lineKey) return;

      if (!selected) {
        await this.request('cart/change.js', {
          id: lineKey,
          quantity: 0,
        });
        return;
      }

      const properties = {
        [this.dataset.messageProperty]: message,
      };

      if (lineKey) {
        await this.request('cart/change.js', {
          id: lineKey,
          quantity: 1,
          properties,
        });
        return;
      }

      await this.request('cart/add.js', {
        items: [
          {
            id: Number(this.dataset.messageVariantId),
            quantity: 1,
            properties,
          },
        ],
      });
    }

    async removeOrphans() {
      const updates = {};

      if (this.dataset.wrapInCart === 'true') {
        updates[this.dataset.wrapVariantId] = 0;
      }

      if (this.dataset.messageLineKey) {
        updates[this.dataset.messageLineKey] = 0;
      }

      if (!Object.keys(updates).length) return;

      try {
        await this.request('cart/update.js', { updates });
        window.location.reload();
      } catch (error) {
        window.cartAddOnsOrphanCleanupStarted = false;
      }
    }

    async request(path, body) {
      const response = await fetch(`${window.Shopify.routes.root}${path}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Cart add-on update failed');
      }

      return response.json();
    }

    setPending(pending) {
      this.setAttribute('aria-busy', pending ? 'true' : 'false');
      this.wrapCheckbox.disabled = pending;
      this.messageCheckbox.disabled = pending;
      this.messageText.disabled = pending || !this.messageCheckbox.checked;
      this.saveButton.disabled = pending;
      this.saveButton.textContent = pending ? this.dataset.saving : this.saveLabel;
    }
  }

  if (!customElements.get('cart-add-ons')) {
    customElements.define('cart-add-ons', CartAddOns);
  }
  } catch(e) { console.error(e); }
})();

})();
